import type { ServeErrorMessage } from '@customerio/hydra-ui-api';
import type { IconName } from '@customerio/pluma-icons';

/** The device platforms push messages are sent to. */
export type PushPlatform = 'ios' | 'android' | 'web';

/** The glyph for the web platform, importable without the feature's components or styles. */
export const WEB_PUSH_ICON: IconName = 'browser';

/** The push services a platform can send through. */
export type PushProvider = 'apns' | 'fcm' | 'webpush';

/** The credential slot each provider stores its authorization in. */
export type PushActionType = 'push_apns' | 'push_fcm' | 'push_webpush';

/**
 * Which part of a push settings page produced an error: saving the provider
 * configuration, or sending a test push. A configuration error supersedes any
 * send-test errors on screen, so the two are told apart.
 */
export type PushErrorType = 'config' | 'sendTest';

/** One error entry from a `ui_api` error response. */
export type PushApiError = ServeErrorMessage;

/**
 * An API error held for display on a push settings page. `updated` is the unix
 * second the error was recorded, so a list can show the newest first.
 */
export type PushConfigError = PushApiError & {
  updated: number;
  type: PushErrorType;
};
